"use client";

import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { LoadingSpinner } from "@/components/ui/loading-spinner";

interface OAuthLoadingModalProps {
    open: boolean;
    message?: string;
    source?: string;
}

const sourceMessages: Record<string, string> = {
    google: "Logging in with Google...",
    whatsapp: "Logging in with WhatsApp...",
};

export function OAuthLoadingModal(
    { open, message = "Processing third-party login...", source }: OAuthLoadingModalProps,
) {
    const displayMessage = source && sourceMessages[source] ? sourceMessages[source] : message;

    return (
        <Dialog open={open} enableBackInterceptor={false}>
            <DialogContent
                className="max-w-[320px] rounded-xl p-8 flex flex-col items-center gap-4"
                showCloseButton={false}
            >
                <LoadingSpinner size="lg" className="size-12" />
                <DialogTitle className="text-base text-t3 text-center font-medium">{displayMessage}</DialogTitle>
                <DialogDescription className="text-xs text-t3 text-center">
                    Please wait while we verify your identity
                </DialogDescription>
            </DialogContent>
        </Dialog>
    );
}
